import { ApolloClient, InMemoryCache, createHttpLink } from "@apollo/client";

export const httpLinkConfig = {
    uri: 'https://api-next.strivere.com/graphql'
};

export const httpLink = createHttpLink(httpLinkConfig);
console.log("Apollo Client URI:", httpLink);
const client = new ApolloClient({
    link: httpLink,
    cache: new InMemoryCache(),
});
export default client;
//http://localhost:4000/graphql
//http://54.84.24.120:4000/graphql
